import * as React from 'react';
import {Form} from 'react-bootstrap';

import styles from './PropertiesBox.less';

interface OwnProps {
  label?: string;
  maxHeight?: string;
  children: React.ReactNode;
}

type Props = OwnProps;

export const PropertiesBox: React.FC<Props> = (props) => {
  const {children, label, maxHeight} = props;
  return (
    <div className={styles.dlPropertiesBox}>
      <Form.Group controlId='formControlsPropertiesBox'>
        {label ? (
          <Form.Label className={styles.dlPropertiesBoxLabel} title={label}>
            {label}
          </Form.Label>
        ) : null}
        <div
          className={styles.dlPropertiesBoxContent}
          style={maxHeight ? {maxHeight} : {}}
        >
          {children}
        </div>
      </Form.Group>
    </div>
  );
};

PropertiesBox.displayName = 'PropertiesBox';
